/**
 * Accepted MIME types for file upload.
 * Supports CSV, XLSX (Office Open XML), and XLS (legacy Excel).
 */
export const ACCEPTED_MIME_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
] as const;

/**
 * Polling interval in milliseconds for checking job status.
 */
export const POLLING_INTERVAL_MS = 4000;

/**
 * Maximum number of polling attempts before timeout (300 * 4s = 20 minutes).
 */
export const MAX_POLL_ATTEMPTS = 300;

/**
 * File size threshold in bytes (10MB). Files exceeding this show estimated upload time.
 */
export const FILE_SIZE_THRESHOLD_BYTES = 10 * 1024 * 1024;

/**
 * Checks whether a given MIME type is accepted for file upload.
 */
export function isAcceptedFileType(mimeType: string): boolean {
  return (ACCEPTED_MIME_TYPES as readonly string[]).includes(mimeType);
}
